"use strict";

Shopify.theme.jsCollectionList = {
  init: function init($section) {
    // Add settings from schema to current object
    Shopify.theme.jsCollectionList = $.extend(this, Shopify.theme.getSectionData($section));

    var collectionListSlider = $('.collection-list__slider');
    collectionListSlider.slick({
        slidesToShow: 4,
        arrows: false,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 798,
                settings: {
                  arrows: true,
                  slidesToShow: 2,
                  centerMode: false,
                  infinite: true,
                  variableWidth: true
                }
            }
        ],
        prevArrow: '<button type="button" class="collection-list-arrow prev-button-collection"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43"><defs><style>.flick-a{fill:#d9d9d9;}.flick-b{fill:#fff;stroke:#d9d9d9;}</style></defs><g transform="translate(0.5 0.5)"><circle class="flick-a" cx="15" cy="15" r="15" transform="translate(5 5)"/><path class="flick-b" d="M45.375,24.375a21,21,0,1,1-21-21A21,21,0,0,1,45.375,24.375Zm-24.685,0,8.269-8.188A1.949,1.949,0,0,0,26.2,13.431l-9.632,9.662a1.946,1.946,0,0,0-.061,2.686L26,35.3a1.945,1.945,0,1,0,2.756-2.746Z" transform="translate(-3.375 -3.375)"/></g></svg></button>',
        nextArrow: '<button type="button" class="collection-list-arrow next-button-collection"><svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43"><defs><style>.flick-a{fill:#d9d9d9;}.b{fill:#fff;stroke:#d9d9d9;}</style></defs><g transform="translate(243.5 -1097.5)"><circle class="flick-a" cx="15" cy="15" r="15" transform="translate(-236 1103)"/><path class="flick-b" d="M3.375,24.375a21,21,0,1,0,21-21A21,21,0,0,0,3.375,24.375Zm24.685,0-8.269-8.188a1.949,1.949,0,0,1,2.756-2.756l9.632,9.662a1.946,1.946,0,0,1,.061,2.686L22.75,35.3a1.945,1.945,0,1,1-2.756-2.746Z" transform="translate(-246.375 1094.625)"/></g></svg></button>',
    });
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
};